import { render, staticRenderFns } from "./HeritageDivisionPage.vue?vue&type=template&id=3c2d4637&scoped=true&"
import script from "./HeritageDivisionPage.vue?vue&type=script&lang=js&"
export * from "./HeritageDivisionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2d4637",
  null
  
)

export default component.exports